import React from 'react';
import styled from '@emotion/styled';
import { BodyTextMedium, HeadingText40 } from '@modernhealth/vital-components';
import { colors } from '@modernhealth/vital-foundation';
import { RsvpQuestion } from '@modernhealth/circles-web-components';
import { CircleRsvpQuestionFragment } from '@modernhealth/circles-graphql/v2';

const NoteText = styled(BodyTextMedium)({
    color: colors.gray85,
    fontWeight: 600,
    marginBottom: 32,
});

export type AnswerContents = {
    answerText?: string | boolean;
    answerId?: string;
};

export interface QuestionAnswer extends AnswerContents {
    /**
     * The question ID
     */
    id: string;
}

export type QuestionAnswers = Record<string, AnswerContents>;

interface QuestionsProps {
    questions: CircleRsvpQuestionFragment[];
    questionAnswers: QuestionAnswers;
    setQuestionAnswer: (answer: QuestionAnswer) => void;
    showErrors: boolean;
    note?: string | null;
}

export const RsvpQuestions: React.FC<QuestionsProps> = ({
    questions,
    questionAnswers,
    setQuestionAnswer,
    showErrors,
    note,
}) => {
    return questions && questions.length ? (
        <div css={{ marginBottom: '32px' }}>
            <HeadingText40>About this Session</HeadingText40>
            {note ? <NoteText>{note}</NoteText> : null}
            {questions.map(question => {
                if (!question) return null;
                const answerValue =
                    question.__typename === 'CircleDropdownQuestionNode' ||
                    question.__typename === 'CircleRadioGroupQuestionNode'
                        ? questionAnswers[question.id]?.answerId
                        : questionAnswers[question.id]?.answerText;

                return (
                    <RsvpQuestion
                        key={question.id}
                        question={question}
                        answer={answerValue ?? ''}
                        setAnswer={setQuestionAnswer}
                        showErrors={showErrors}
                    />
                );
            })}
        </div>
    ) : null;
};
